import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo, useRef } from "react";
import { Carousel, ChevronLeft, ChevronRight, IconButton, Typography } from "@parkschannel/ui";
import { usePlanner } from "../../../TripPlanner";
import { CarouselItemSkeleton } from "./CarouselItemSkeleton";
import { CarouselItem } from "./CarouselItem";
import classNames from "classnames";
const responsive = {
    0: {
        items: 1
    },
    500: {
        items: 2
    },
    700: {
        items: 3
    },
    1100: {
        items: 4
    },
    1250: {
        items: 5
    }
};
export const ProductCarousel = /*#__PURE__*/ memo((param)=>{
    let { productId  } = param;
    const carouselRef = useRef(null);
    const { useProductItemsQuery  } = usePlanner();
    const { data , isLoading  } = useProductItemsQuery(productId);
    const slideNext = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slideNext(null);
    };
    const slidePrev = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slidePrev(null);
    };
    const slides = useMemo(()=>{
        if (isLoading) {
            return [
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {}),
                /*#__PURE__*/ _jsx(CarouselItemSkeleton, {})
            ];
        }
        return data === null || data === void 0 ? void 0 : data.map((item)=>/*#__PURE__*/ _jsx(CarouselItem, {
                data: item
            }, item.id));
    }, [
        productId,
        data,
        isLoading
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "min-h-[194px] flex flex-col",
        children: [
            (data === null || data === void 0 ? void 0 : data.length) === 0 && /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyLarge",
                className: "text-neutral-800 text-center mt-8",
                children: "Not found"
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                responsive: responsive,
                disableDotsControls: true,
                ref: carouselRef,
                infinite: false,
                paddingRight: 20,
                items: slides,
                autoWidth: true
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "hidden w-full mt-2 lg:flex lg:gap-1 lg:justify-end",
                children: [
                    /*#__PURE__*/ _jsx(IconButton, {
                        size: "sm",
                        variant: "base",
                        icon: /*#__PURE__*/ _jsx(ChevronLeft, {
                            className: classNames("w-5 h-5")
                        }),
                        onClick: slidePrev
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        size: "sm",
                        variant: "base",
                        icon: /*#__PURE__*/ _jsx(ChevronRight, {
                            className: classNames("w-5 h-5")
                        }),
                        onClick: slideNext
                    })
                ]
            })
        ]
    });
});
